import { render, staticRenderFns } from "./NamespaceTranslator.vue?vue&type=template&id=143e822a&"
import script from "./NamespaceTranslator.vue?vue&type=script&lang=js&"
export * from "./NamespaceTranslator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports